import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable, firstValueFrom, from } from 'rxjs'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from 'src/app/core/models'
import { ProviderInfo } from 'src/app/shared/models/provider-info.model'

@Injectable()
export class DataProviderInfoService {
  constructor(
    private readonly http: HttpClient,
    @Inject(APP_CONFIG) private readonly config: AppConfigModel,
  ) {}

  loadProviderInfo(): Observable<ProviderInfo> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }

    const url = `${this.config.backend_url}vzo/providers`

    return from(firstValueFrom(this.http.get<ProviderInfo>(url.toString(), httpOptions)))
  }
}
